import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    adminRoleNav: null
}

const adminRole = createSlice({
    name: "adminRole",
    initialState,
    reducers: {
        setAdminRoleData: (state, action) => {
            state.adminRoleNav = action.payload.roles
        },
        deleteRoleData: (state) => {
            state.adminRoleNav = null
        }
    }
})

export const {deleteRoleData, setAdminRoleData} = adminRole.actions
export default adminRole.reducer